// Sass
import './Sass/includes/_general.sass'
import './Sass/includes/Components/modules/C12.sass'

import C12PeopleOrg from './Components/Organisms/Personas/C12'
import C12PeopleOrgWithoutFil from './Components/Organisms/Personas/C12/v2-WithoutFil'

function App() {
  function version2() {
    return localStorage.getItem('hide_product_promo')
  }
  return (
    <div className="App">
      {
        version2() === 'true' ? <C12PeopleOrgWithoutFil /> : <C12PeopleOrg />
      }
    </div>
  );
}

export default App;
